var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Zm4.974-12.78a.692.692 0 0 1 .108.972l-5.75 7.188a.704.704 0 0 1-.14.137.693.693 0 0 1-.91-.077l-2.87-2.87a.692.692 0 0 1 .98-.98l2.332 2.334 5.277-6.596a.692.692 0 0 1 .973-.109Z",
    fill: "#37AD4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTickGreen);
export default __webpack_public_path__ + "static/media/circle-tick-green.4e8d8d354a7627b98cad42341013af8e.svg";
export { ForwardRef as ReactComponent };